import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Basic imports that most components need
export const COMMON_IMPORTS = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule];

// CDK imports for advanced components
export const CDK_IMPORTS = [A11yModule, OverlayModule, PortalModule];

// All imports combined
export const ALL_IMPORTS = [...COMMON_IMPORTS, ...CDK_IMPORTS];

// Import categories for different component types
export const FORM_IMPORTS = [CommonModule, FormsModule, ReactiveFormsModule];

export const ROUTER_IMPORTS = [CommonModule, RouterModule];

export const OVERLAY_IMPORTS = [CommonModule, ...CDK_IMPORTS];
